var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.790039,
    width: 60,
    height: 60,
    rx: 16,
    fill: "#EEB686"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8337_42783)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8337_42783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6265 37.2303L39.1465 41.4437C39.2799 42.5503 38.0932 43.3237 37.1465 42.7503L32.5332 40.0037C32.2132 39.817 32.1332 39.417 32.3065 39.097C32.9732 37.8703 33.3332 36.4837 33.3332 35.097C33.3332 30.217 29.1465 26.2437 23.9999 26.2437C22.9465 26.2437 21.9199 26.4037 20.9599 26.7237C20.4665 26.8837 19.9865 26.4303 20.1065 25.9237C21.3199 21.0704 25.9865 17.457 31.5599 17.457C38.0665 17.457 43.3332 22.377 43.3332 28.4437C43.3332 32.0437 41.4799 35.2303 38.6265 37.2303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3337 35.0966C31.3337 36.6832 30.747 38.1499 29.7603 39.3099C28.4403 40.9099 26.347 41.9366 24.0003 41.9366L20.5203 44.0032C19.9337 44.3632 19.187 43.8699 19.267 43.1899L19.6003 40.5632C17.8137 39.3232 16.667 37.3366 16.667 35.0966C16.667 32.7499 17.9203 30.6832 19.8403 29.4566C21.027 28.6832 22.4537 28.2432 24.0003 28.2432C28.0537 28.2432 31.3337 31.3099 31.3337 35.0966Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8337_42783"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14.79,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8337_42783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 14.79)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundYellow);
export default __webpack_public_path__ + "static/media/backgroundYellow.ff649adebd242d551ec20d629a4d72a6.svg";
export { ForwardRef as ReactComponent };